<template>
  <div>
    <h4>{{ title }}</h4>
    <small v-html="text" />
    <div v-if="development">{{ debug }}</div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    text: {
      type: String,
      default: null,
    },
    debug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      development: process.env.NODE_ENV === "development",
    }
  },
}
</script>
